











































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

import {
    TransportLoad,
    TransportLoadTask
} from "../models";

@Component
export default class LoadTaskSelect extends Vue {
    @Prop() extended!: boolean;
    @Prop() showLoad!: boolean;
    @Prop() index!: number;
    @Prop() load!: TransportLoad;
    @Prop() loadTask!: TransportLoadTask;

    get linesText(): string {
        const task = this.loadTask.task;

        const items = [{
            partId: task.partId,
            partDescription: task.partDescription
        }].concat(task.lines.map(l => ({
            partId: l.partId,
            partDescription: l.partDescription
        })))
        .filter(l => !l.partId.startsWith("9"));

        return items
            .map(i => i.partDescription)
            .join(", ");
    }
}
